import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DocumentHistory } from '../models/DocumentHistory';
import { HistoryBaseService } from '../../services/history-base.service';
import { DocumentHistoryDetail } from '../models/DocumentHistoryDetail';

@Injectable()
export class DocumentHistoryDetailService extends HistoryBaseService<DocumentHistoryDetail> {
  /**
   *
   */
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, 'DocumentHistorys', 'History');
  }
  GetDownloadLink(id: string) {
    return `${this.rootUrl}/${this.endpoint}/${this.singular}/Download/${id}`;
  }
}
